import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import _ from 'lodash';

// import { TABLET_P } from '@/constants';
import Image from '../../../components/ContentfulImage';

import {
  Benefit,
  BenefitsWrapper,
  Description,
  DescriptionWrapper,
  ImageWrapper,
  InfoWrapper,
  Title,
  TitleWrapper,
  Wrapper,
  ButtonWrapperJp,
  ButtonJp,
  // PlaceholderWrapper,
} from './RangeHeroOverview.style';
import Markdown from '../../../components/Markdown';
import Placeholder from '../../../components/Placeholder';
import { scrollToElementById } from '../../../utils';

class RangeHeroOverview extends React.Component {
  static defaultProps = {
    image: undefined,
    targetConditions: undefined,
    product: undefined,
    description: undefined,
    locale: undefined,
    salonListCta: {},
    quickLinks: undefined,
    productLists: undefined,
  };

  static propTypes = {
    copy: PropTypes.shape().isRequired,
    hasProducts: PropTypes.bool.isRequired,
    location: PropTypes.shape({}).isRequired,
    image: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
      file: PropTypes.shape({
        url: PropTypes.string,
        details: PropTypes.shape({
          size: PropTypes.number,
          image: PropTypes.shape({
            width: PropTypes.number,
            height: PropTypes.number,
          }),
        }),
        fileName: PropTypes.string,
      }),
    }),
    product: PropTypes.string,
    description: PropTypes.string,
    targetConditions: PropTypes.arrayOf(PropTypes.string),
    locale: PropTypes.string,
    salonListCta: PropTypes.shape(),
    quickLinks: PropTypes.arrayOf(PropTypes.shape()),
    productLists: PropTypes.arrayOf(PropTypes.shape()),
  };

  scrollToProdcuts = (anchorLabel, quickLinks, productLists) => {
    // quickLinks.map(link => {
    //   if (link.label === anchorLabel) {
    //     scrollToElementById(link.id);
    //   }
    // });

    // quickLinks の ID に対応した productList に、1つ以上の products が設定されている場合
    quickLinks.map(link => {
      if (link.label === anchorLabel) {
        const linkId = link.id;
        if (linkId && productLists && productLists.length > 0) {
          productLists.some(productList => {
            if (productList.entryId === linkId && productList.products && productList.products.length > 0) {
              scrollToElementById(productList.entryId);
              return true;
            }
          });
        }
      }
    });

    // ↑の条件に合致しない場合は、productLists の一番上のリストにアンカーリンクする
    if (productLists && productLists.length > 0) {
      productLists.some(productList => {
        if (productList.products && productList.products.length > 0) {
          scrollToElementById(productList.entryId);
          return true;
        }
      });
    }
  };

  render = () => {
    const {
      copy,
      hasProducts,
      image,
      product,
      description,
      targetConditions,
      locale,
      salonListCta,
      quickLinks,
      location,
      productLists,
    } = this.props;

    return (
      <Wrapper>
        <ImageWrapper>
          {image ? (
            <Image src={image} options={{ w: '100%', size: [600, 900, 1200, 1440] }} />
          ) : (
            <Placeholder w="100%" pb="46.875%" />
          )}
        </ImageWrapper>

        <InfoWrapper>
          <TitleWrapper>
            <Title>{product || <Placeholder w="45%" pb="10%" />}</Title>
            {(!product || targetConditions) && (
              <BenefitsWrapper>
                {targetConditions
                  ? targetConditions.map(condition => <Benefit key={condition}>{condition}</Benefit>)
                  : [1, 3, 2].map(key => (
                      <Benefit key={key}>
                        <Placeholder w={`${key * 25}%`} h="25px" />
                      </Benefit>
                    ))}
              </BenefitsWrapper>
            )}
          </TitleWrapper>

          <DescriptionWrapper>
            {description ? <Markdown src={description} Component={Description} /> : <Placeholder w="100%" pb="35%" />}
          </DescriptionWrapper>
        </InfoWrapper>

        <React.Fragment>
          {hasProducts &&
            _.get(copy, 'view_products') &&
            salonListCta &&
            Object.keys(salonListCta) && (
              <ButtonWrapperJp>
                {/* 「商品を見る」ボタン */}
                {Object.keys(salonListCta).length === 0 && (
                  <ButtonJp onClick={() => this.scrollToProdcuts('PRODUCTS', quickLinks, productLists)}>
                    {copy.view_products}
                  </ButtonJp>
                )}
                {Object.keys(salonListCta).length > 0 && (
                  <React.Fragment>
                    {/* 「商品を見る」ボタン */}
                    <ButtonJp onClick={() => this.scrollToProdcuts('PRODUCTS', quickLinks, productLists)}>
                      {copy.view_products}
                    </ButtonJp>
                    {/* 「取扱サロン一覧」ボタン */}
                    <Link
                      className="button"
                      to={{
                        pathname: `/${locale}${salonListCta.linkUrl}`,
                        state: {
                          prevPath: location.pathname,
                        },
                      }}
                      href={`/${locale}${salonListCta.linkUrl}`}
                    >
                      {salonListCta.label}
                    </Link>
                  </React.Fragment>
                )}
              </ButtonWrapperJp>
            )}
        </React.Fragment>
      </Wrapper>
    );
  };
}

export default RangeHeroOverview;



// WEBPACK FOOTER //
// ./src/pages/RangePage/RangeHeroOverview/RangeHeroOverview.js